<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher(); 

    let mouseDownAction = () => {
		dispatch('mousedown');
	};

    export let title;
    export let icon;
    export let value;
    export let color = "info";
    export let withFooter = false;
    export let id = "";
    export let active = false;
    export let disabled = false;
</script>

<div id="{id}" class="card {active === true ? 'active' : ''} {disabled === true ? 'disabled' : ''}" on:mousedown={mouseDownAction} class:active={active}>
    <div class="d-flex justify-content-between">
         <div class="mt-3 ml-3">
            <i class="fa fa-{icon} text-{color}"></i>
        </div>
        <div class="text-{color}">
            <h6>{title}</h6>
            <h1 class="font-weight-bold">{value}</h1>
        </div>
    </div>    
</div>

<style>
    .card {
        border-radius: 10px;
        transition: all 0.3s ease-in-out;
        background-color: #fff;
        padding: 0px!important;
        opacity: 0.8;
        box-shadow: 0 2px 4px 2px #00aec92a;
    }
    
    .card h6{
        max-width: 150px;
        font-weight: 600;
    }

    .card-footer{
        position: sticky;
        padding : 0px !important;
        height: 50px;
        background-color: #fcfbfb;
        border-top: none;
        font-weight: bold;
        border-bottom: 10px;
        border-radius: 0, 0, 10px, 10px;
    }

    .card:hover {
        transform: scale(1.02);
        cursor: pointer;
    }
    
    .active{
        border: 3px solid var(--primary);
        border-radius: 10px ;
        padding: 4px;
        opacity: 1;
    }

    .disabled{
        pointer-events: none;
    }

    .card i{
        opacity: 0.5;
        font-size: 50px;
        color: #e9ecef;
        margin: 10px;
    }

    @media(max-width: 1600px){
        .card h6{
            font-size: 0.8em;
            max-width:100px;
        }

         .card-footer{        
            font-size: 0.8em;
    }
}

</style>